import React from 'react';
import Header from '../../components/common/header';
import Footer from '../../components/common/footer';

function Acessibilidade() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header size={10} />
      <main className="flex-grow container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-8">Acessibilidade</h1>
        
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Recursos de Acessibilidade</h2>
          <p className="mb-4">O EstimaGás está comprometido em tornar seu conteúdo acessível para todos os usuários. Oferecemos os seguintes recursos de acessibilidade:</p>
          
          <div className="space-y-6">
            <div>
              <h3 className="text-xl font-semibold mb-2">Inversão de Cores</h3>
              <p>Para melhorar a legibilidade, oferecemos a opção de inverter as cores da página. Este recurso pode ser ativado através do botão "Inverter Cores" no cabeçalho do site.</p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-2">Navegação por Teclado</h3>
              <p>Todas as funcionalidades do site podem ser acessadas usando apenas o teclado:</p>
              <ul className="list-disc ml-6 mt-2">
                <li>Use Tab para navegar entre elementos</li>
                <li>Enter ou Espaço para ativar botões e links</li>
                <li>Setas direcionais para navegar em menus e tabelas</li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-2">Texto e Contraste</h3>
              <p>O site foi desenvolvido com atenção especial ao contraste entre texto e fundo, seguindo as diretrizes de acessibilidade WCAG 2.1.</p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-2">Imagens e Gráficos</h3>
              <p>Todas as imagens e gráficos incluem descrições alternativas (alt text) para usuários que utilizam leitores de tela.</p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-2">Responsividade</h3>
              <p>O site é totalmente responsivo e pode ser acessado em diferentes dispositivos e tamanhos de tela, mantendo sua funcionalidade e legibilidade.</p>
            </div>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Compromisso com a Acessibilidade</h2>
          <p>Estamos constantemente trabalhando para melhorar a acessibilidade do EstimaGás. Se você encontrar alguma dificuldade ou tiver sugestões para melhorar nossa acessibilidade, por favor, entre em contato conosco.</p>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default Acessibilidade;
